import { useState } from 'react';
import { CloseIcon } from '../../assets/svg';
import Modal from 'react-bootstrap/Modal';

export default function ContentModal(props) {
    // const [show, setShow] = useState({
    //     name:''
    // })
    // const handleChange = (e) => (
    //     setShow({...show,
    //         [e.target.name]:e.target.value
    //     })
    // )
    return (
        <>
            <div onClick={props.openModal} className="cursor-pointer d-inline-block">
                {props.modalName}
            </div>
            <Modal
                show={props.show}
                centered
                onHide={props.handleClose}
                className="custom-modal"
            >
                <Modal.Header>
                    <Modal.Title>{props.heading}</Modal.Title>
                    <button type="button" className="close" onClick={props.handleClose}>
                        <CloseIcon/>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {props.body}
                    {/* <input type="text" onChange={handleChange} name="name" value={show.name} /> */}
                </Modal.Body>




                <Modal.Footer className="mt-md-4 mt-2">
                    {props.heading=="Confirm plan & pay" ||props.heading=="Change plan"?
                        <span
                            className="c_pointer font-weight-bold classUnderLine1"
                            onClick={props.showPromoBox}
                        >
                                 ENTER PROMO CODE
                          </span>
                        :''}
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-black px-3 text-uppercase"
                        onClick={props.submitModal}
                    >
                        {props.firstBtn}
                    </button>
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-gray1 px-3 text-uppercase"
                        onClick={props.handleClose}
                    >
                        {props.secondBtn}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
